// extracted by mini-css-extract-plugin
export default {"SnackbarItem-variantSuccess":"ccpa_SnackbarItem-variantSuccess__2Gb80","SnackbarContainer-root":"ccpa_SnackbarContainer-root__qdOTq","banner_sec":"ccpa_banner_sec__SMrH7"};